import { render, staticRenderFns } from "./storeHome.vue?vue&type=template&id=6d74fa7a&scoped=true"
import script from "./storeHome.vue?vue&type=script&lang=js"
export * from "./storeHome.vue?vue&type=script&lang=js"
import style0 from "./storeHome.vue?vue&type=style&index=0&id=6d74fa7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d74fa7a",
  null
  
)

export default component.exports